import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import {ScriptSoundAmbiant} from './soundambiant.script.js';

import ambiant from './Aperture-Tag-OST-28-Central-Hub-_152kbit_Opus_.mp3';
// import ambiant2 from './Fountain Water Bubbling.mp3';

function gameobjectsoundambiant() {

    const soundambiant = new HYPERCUBEJS.Node('soundambiant');
    const meshsoundambiant = new HYPERCUBEJS.MeshBox('meshsoundambiant', [1, 1, 1]);
    const materialmeshsoundambiant = new HYPERCUBEJS.MaterialColor('materialmeshsoundambiant', {'color': [0.0, 0.0, 0.0]});

    meshsoundambiant.setmaterial(materialmeshsoundambiant);
    meshsoundambiant.setshadowcasting(false);
    soundambiant.addmesh(meshsoundambiant);
    soundambiant.setaudio(new Audio(ambiant));
    soundambiant.setscript(new ScriptSoundAmbiant());

    // soundambiant.setcomponent('collideraabb', {

    //     'type': 'static',

    //     'min': [-0.5, -0.5, -0.5],
    //     'max': [0.5, 0.5, 0.5]
    // });

    return soundambiant;
}

export {

    gameobjectsoundambiant
};

export default gameobjectsoundambiant;
